import { useEffect, useState } from 'react'
import SignalsService from '../../services/communication/signals.service'
import { SIGNAL_EVENT } from '../../types/enums'

// componente che mostra il loader qual ora la signal showLoader viene sparata
const Loader = () => {
  const [displayStyle, setDisplayStyle] = useState<String>('hidden')

  useEffect(() => {
    SignalsService.on(SIGNAL_EVENT.showLoader, (value: string) => {
      setDisplayStyle(value)
    })
  }, [])

  return (
    <div
      id={'containerLoader'}
      className={`fixed ${displayStyle} items-center justify-center bg-black bg-opacity-50 w-screen h-screen top-0 z-50`}>
      <div id={'loader'}></div>
    </div>
  )
}

export default Loader
